<template>
    <div>
      <div class="popup-info popup-icon-info">
          <svg style="height: 48px;">
            <use xlink:href="@/assets/img/big-icons-sprite.svg#trash2"></use>
          </svg>

          <div class="text mt24">
              <div class="text-size-l text-bold info-title">Удалить правило?</div>

              <p class="info-text mt16">
                  Это действие нельзя отменить.
              </p>
          </div>

          <div class="mt24">
              <submit-btn @click.native="remove" :type="btnType"><span class="i i-ok7 mr8"></span>Подтвердить</submit-btn>
          </div>
      </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';
    import SubmitBtn from '@/components/forms/SubmitBtn.vue'

    export default {
        name: "RemoveRule",
        components: {
            SubmitBtn
        },
        data() {
            return {
                btnType: 'normal',
            }
        },
        props: {
        },
        methods: {
            remove(){
                this.btnType = 'load';

              this.$store.dispatch('rules/checkEditItem', this.item).then((result) => {
                if (result.status) {
                  this.btnType = 'normal';
                  this.$store.commit('popups/close', {name: this.popups.removeRule.name});
                  this.$store.commit('popups/open', {name: this.popups.removeDisabled.name});
                } else {
                  this.$store.dispatch('rules/removeRule', {
                    id: this.item.id,
                    forever: false,
                    section: this.item.sectionTop,
                    subSection: this.item.section,
                  }).then(() => {
                    this.btnType = 'ok';
                    this.$store.commit('popups/close', {name: this.popups.removeRule.name});
                    this.$store.commit('popups/close', {name: this.popups.addRule.name});
                    this.$store.commit('popups/close', {name: this.popups.ruleDetail.name});
                    if(document.querySelector('.rules')){document.querySelector('.rules').style.opacity = ''};
                  });
                }
              });


            },
            close: function () {
                this.$store.commit('popups/close', {name: this.popups.removeRule.name});
            }
        },
        computed: {
            ...mapState({
                popups: state => state.popups.items,
                item: state => state.rules.openedRule,
                topSections: state => state.rules.topSections,
            }),
            activeTopSection(){
                if(this.isSearch) return false;
                return this.$route.params.id ? this.$route.params.id : this.topSections[0].id;
            },
        }
    }
</script>

<style scoped>

</style>
